import { LoadingButton } from '@mui/lab'
import { Dialog, DialogContent, Grid, DialogTitle, TextField, DialogActions, Button, InputAdornment } from '@mui/material'
import { GreenText } from 'components'
import { SettingsMichiganTitleFeeDto, settingsMichiganTitleFeeValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface MichiganTitleFeeAddEditDialogProps {
  initialValues: SettingsMichiganTitleFeeDto
  open: boolean
  isLoading: boolean
  onClose: () => void
  onSave: (values: any) => void
}

export default function MichiganTitleFeeAddEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: MichiganTitleFeeAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange
        validateOnBlur
        validationSchema={settingsMichiganTitleFeeValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Michigan Title Fee</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.michiganTitleFee && errors.michiganTitleFee)}
                      helperText={touched.michiganTitleFee && errors.michiganTitleFee}
                      InputProps={{
                        startAdornment: <InputAdornment position='start'>$</InputAdornment>
                      }}
                      label='Title Fee Amount'
                      name='michiganTitleFee'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.michiganTitleFee}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <GreenText variant='outlined'>
                    {`**Title Fee Amount Field:**

Allows users to input the title fee amount for Michigan Title Fees. This is a
free-text, numeric-only field.

---

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save any changes

---

**SAVE Button:**

Clicking the SAVE button will save any changes.

---
`}
                  </GreenText>
                </Grid>

                <DialogActions>
                  <Button disabled={isLoading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                    CANCEL
                  </Button>

                  <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                    SAVE
                  </LoadingButton>
                </DialogActions>
              </DialogContent>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
